module.exports = __webpack_public_path__ + "static/img/invoicedirect_grey.db3d8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/invoicedirect_grey.png
// module id = 1483
// module chunks = 2